import { Node } from "#/decision_tree_viewer/models/node";

export class ChangeVisitTypeNode extends Node {
  get defaults() {
    return {
      ...super.defaults,
      name: "ChangeVisitTypeNode",

      visitTypeId: undefined,
      targetNodeId: "continue",

      switchDecisionTree: false,
    };
  }

  get context() {
    return { visitTypeId: this.visitTypeId };
  }

  get possibleNextNodeIds() {
    return [this.targetNodeId];
  }

  autoAdvance() {
    return true;
  }

  nextNodeId(context) {
    return this.determineDecisionTreeSwitch(this.visitTypeId, context).nodeId;
  }

  isDecisionTreeSwitch(context) {
    return this.determineDecisionTreeSwitch(this.visitTypeId, context).isSwitch;
  }
}
